import React, { useState, useEffect } from "react";
import FlagOption from "./FlagOption";
import ScoreBoard from "./ScoreBoard";
import { countries } from "../data/countries";
import "./FlagGame.css";

const FlagGame = () => {
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [score, setScore] = useState(0);
  const [totalQuestions, setTotalQuestions] = useState(0);

  useEffect(() => {
    generateNewQuestion();
  }, []);

  const generateNewQuestion = () => {
    const options = [];
    const usedIndexes = new Set();

    // Get 4 random countries
    while (options.length < 4) {
      const randomIndex = Math.floor(Math.random() * countries.length);
      if (!usedIndexes.has(randomIndex)) {
        usedIndexes.add(randomIndex);
        options.push(countries[randomIndex]);
      }
    }

    // Randomly select one as the correct answer
    const correctIndex = Math.floor(Math.random() * options.length);

    setCurrentQuestion({
      options,
      correctAnswer: options[correctIndex],
      correctIndex,
    });
  };

  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [showFeedback, setShowFeedback] = useState(false);

  const handleGuess = (selectedCountry) => {
    if (!currentQuestion || showFeedback) return;

    const isCorrect =
      selectedCountry.code === currentQuestion.correctAnswer.code;
    setSelectedAnswer({ country: selectedCountry, isCorrect });
    setShowFeedback(true);

    if (isCorrect) {
      setScore((prev) => prev + 1);
    }
    setTotalQuestions((prev) => prev + 1);

    // Wait a moment to show feedback before next question
    setTimeout(() => {
      setShowFeedback(false);
      setSelectedAnswer(null);
      generateNewQuestion();
    }, 2000);
  };

  if (!currentQuestion) {
    return (
      <div className="loading">
        <h2>Loading game...</h2>
        <p>Please wait</p>
      </div>
    );
  }

  return (
    <div className="flag-game">
      <ScoreBoard score={score} totalQuestions={totalQuestions} />

      <div className="flag-display">
        <img
          src={`https://flagcdn.com/w640/${currentQuestion.correctAnswer.code.toLowerCase()}.png`}
          alt="Country flag to guess"
          className="main-flag"
        />
      </div>

      <div className="options-container">
        {currentQuestion.options.map((country, index) => (
          <FlagOption
            key={country.cca3}
            country={country}
            onClick={() => handleGuess(country)}
            showFeedback={showFeedback}
            isCorrect={
              selectedAnswer?.country.code === country.code
                ? selectedAnswer.isCorrect
                : undefined
            }
            isCorrectAnswer={
              currentQuestion.correctAnswer.code === country.code
            }
          />
        ))}
      </div>
    </div>
  );
};

export default FlagGame;
